import React from "react";

import dashbordIcon from "../../assets/dashboard_icon.png";
import facultuIcon from "../../assets/faculty_icon.png";
import activityIcon from "../../assets/activity_icon.png";
import reportIcon from "../../assets/reports_icon.png";
import evalIcon from "../../assets/evaluation_icon.png";
import alertsIcon from "../../assets/alerts_icon.png";
import resIcon from "../../assets/resources_icon.png";
import adminIcon from "../../assets/admin_icon.png";
import Typography from "@mui/material/Typography";
import {topBarStyle} from "./topBarStyle";
import {store, useAppDispatch, useAppSelector} from "../../redux/store";
import {clearlogs} from "../../redux/reducers/loggerSlice";
import {isValidObject} from "commonUtils/utils";
import {useNavigate} from "react-router-dom";

export const Topbar: React.FC<any> = ({styleMap}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const ADMIN = "Administration";
  const ADMIN_ID = 8;

  const {authDetails, userDetails, userPreferences} = useAppSelector(state => {
    return state.auth;
  });
  const menus = userPreferences?.menus;

  const iconsMap = new Map([
    ["Dashboard", dashbordIcon],
    ["Faculty", facultuIcon],
    ["Activity", activityIcon],
    ["Reports", reportIcon],
    ["Evaluation", evalIcon],
    ["Alerts", alertsIcon],
    ["Resources", resIcon],
    ["Admin", adminIcon],
    ["Task Management", adminIcon],
  ]);

  const urlClickMaster = (
    link: string,
    isNew: boolean,
    event: any,
    firstSubMenu: string,
    pageId: number,
    menuId: number,
  ) => {
    event.preventDefault();
    dispatch(clearlogs());
    if (isNew) {
      const pathName = location.pathname;
      const currentPage = pathName.slice(1, pathName.length);

      if (
        currentPage.toLowerCase() === pathName?.toLowerCase() ||
        currentPage.toLowerCase() === firstSubMenu?.split("?")[0]?.toLowerCase()
      ) {
        window.location.reload();
      } else {
        const authState = store.getState();
        if (authState.auth?.facultyDetails?.facultyId > 0 && menuId === 2) {
          navigate("/faculty/facultydetails", {
            state: {
              params: `facultyId=${authState.auth?.facultyDetails?.facultyId}&mainPage=0`,
            },
          });
        } else {
          if (!isValidObject(firstSubMenu)) {
            navigate("/" + link);
          } else {
            const pathNameIds = firstSubMenu?.split("?")[1];

            navigate("/" + firstSubMenu?.split("?")[0], {
              state: {
                params: pathNameIds ? pathNameIds : "submenuid=" + pageId,
              },
            });
          }
        }
      }
    }
  };

  return (
    <div className="app-topbar">
      <ul id="menu-main">
        {menus &&
          Object.keys(menus).length > 0 &&
          menus?.map((m: any) => (
            <li
              className={styleMap.get(
                m.id === ADMIN_ID ? ADMIN : m.displayText,
              )}
              title="1"
              key={m.id}>
              <a
                href={m.pageToLoad}
                title={m.displayText}
                onClick={() => {
                  urlClickMaster(
                    m?.pageToLoad,
                    m?.subMenus?.length !== 0 &&
                      m?.subMenus[0]?.pages?.length > 0
                      ? m?.subMenus[0]?.pages[0]?.isNew
                      : m?.subMenus?.length !== 0
                        ? m?.subMenus[0]?.isNew
                        : m?.isNew,
                    event,
                    m?.subMenus?.length !== 0 &&
                      m?.subMenus[0]?.pages?.length > 0
                      ? m?.subMenus[0]?.pages[0]?.pageToLoad
                      : m?.subMenus[0]?.pageToLoad,
                    m?.subMenus?.length !== 0 &&
                      m?.subMenus[0]?.pages?.length > 0
                      ? m?.subMenus[0]?.pages[0]?.id
                      : m?.subMenus[0]?.id,
                    m?.id,
                  );
                }}>
                <Typography component="p" sx={topBarStyle.menuFont}>
                  <img
                    src={iconsMap.get(m.displayText)}
                    alt="my"
                    style={topBarStyle.imgStyle}
                  />
                  {m.displayText}
                </Typography>
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default Topbar;
